import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import APIUrls from "../../../services/APIUrls";
import { useNavigate } from "react-router-dom";
import { getAxiosResponse,putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import { transformBlankToNull } from "../../../services/Util";
import $, { event } from "jquery";
import Constants from "../../../Constants";
import { useSelector } from "react-redux";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { companyInformationSchema } from "../../../ValidationSchema";


export default function SystemSettingCompInformation() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const [editMode, setToggleEditMode] = useState(false);
  const [companyInfo, setCompanyInfo] = useState({});
  const backRef = useRef();
  //const focusRef = useRef();
  const [companyName, setCompanyName] = useState("");
  const [address1, setCompanyAddress1] = useState("");
  const [address2, setCompanyAddress2] = useState("");
  const [city, setCompanyCity] = useState("");
  const [state, setCompanyState] = useState("");
  const [zipcode, setCompanyZipcode] = useState("");
  const [phoneNumber, setCompanyPhoneNumber] = useState("");
  const [accountPayableName, setCompanyAccountPayableContactName] = useState("");
  const [accountPayableEmail, setCompanyAccountPayableEmail] = useState("");
  const [accountPayablePhone, setCompanyAccountPayablePhone] = useState("");
  const [countries, setAllCountries] = useState([]);
  const [industries, setAllIndustries] = useState([]);
  const [customerPreference, setCustomerPreference] = useState({});
  const [selectedCountry,setSelectedCountry] = useState({});
  const [selectedIndustry,setSelectedIndustry] = useState({});
  const [status,setStatus] = useState("");
  const [errors, setErrors] = useState({});

  const companyInfoEdit = () => {
    if(editMode === false){
      setErrors({});
      setCompanyName(companyInfo.name);
      setCompanyAddress1(companyInfo.address1);
      setCompanyAddress2(companyInfo.address2);
      setCompanyCity(companyInfo.city);
      setSelectedCountry({country:companyInfo.country});
      setCompanyState(companyInfo.state);
      setCompanyZipcode(companyInfo.zip);
      setCompanyAccountPayableContactName(companyInfo.financialContactName);
      setCompanyAccountPayableEmail(companyInfo.financialContactEmail);
      setCompanyAccountPayablePhone(companyInfo.financialContactPhone);
      setSelectedIndustry({value:companyInfo.industry});
      setCompanyPhoneNumber(companyInfo.phone);
    }
    setToggleEditMode(!editMode);
  };

  const customerData = useSelector((store) => store.customer_bootstrap_data).value;

  const updateCompanySetting = async () => {
    let dataObject = {
      "companyname":companyName,
      "address1":address1,
      "address2":address2,
      "city":city,
      "state":state,
      "phonenumber":phoneNumber,
      "zipcode":zipcode,
      "country":selectedCountry.country,
      "industry":selectedIndustry.value,
      "accountpayablename":accountPayableName,
      "accountpayableemail":accountPayableEmail,
      "accountpayablephone":accountPayablePhone
    };
    const validationResult = await companyInformationSchema.validate(dataObject,{abortEarly:false})
    .catch((err)=>{
      return err;
    });
    if(!validationResult.errors){
      companyInfo.name = companyName;
      companyInfo.address1 = address1;
      companyInfo.address2 = address2;
      companyInfo.city = city;
      companyInfo.state = state;
      companyInfo.phone = phoneNumber;
      companyInfo.zip = zipcode;
      companyInfo.country = selectedCountry.country;
      companyInfo.industry = selectedIndustry.value;
      companyInfo.financialContactName = accountPayableName;
      companyInfo.financialContactEmail = accountPayableEmail;
      companyInfo.financialContactPhone = accountPayablePhone;
      var payload = transformBlankToNull(companyInfo);
      putAxiosResponse(APIUrls.GET_CUSTOMER_INFORMATION,payload).then((res) => {
        if(res.data.data.statusCode === "BAD_REQUEST"){
          let body = res.data.data.body;
          if(body.errors){
            if(body.errors.financialContactEmail){
              let error = {accountpayableemail:body.errors.financialContactEmail};
              setErrors(error);
            }
          }
        }else{
          companyInfoEdit();
          //setCompanyInfo(res.data.data);
        }
      });
      var data = transformBlankToNull(customerPreference);
      putAxiosResponse(APIUrls.GET_CUSTOMER_PREFERENCE + `?preference=STRIPE_ENABLED`,data)
      .then((res)=>{
         setCustomerPreference(res.data.data);
      });
    }else {
      let dataErrors = {};
      validationResult.inner.forEach((element) => {
        dataErrors[element.path] = element.message;
      });
      setErrors(dataErrors);
    }
  };
  const handleCountrySelect = (e) =>{
    enableSave();
    setSelectedCountry(e.value)
  }
  const handleIndustrySelect = (e) => {
    enableSave();
    setSelectedIndustry(e.value)
  }

  const getCompanyInfo = ()=>{
    getAxiosResponse(APIUrls.GET_CUSTOMER_INFORMATION).then((res) => {
      const data = res.data.data;
      setCompanyInfo(data);
      setSelectedCountry(data.country);
      setSelectedIndustry({value:data.industry});
    });
  };

  const getStripsInfo = ()=>{
    getAxiosResponse(APIUrls.GET_CUSTOMER_PREFERENCE + `?preference=STRIPE_ENABLED`).then((res) => {
      setCustomerPreference(res.data.data);
    });
  };

  const getAllCountries = ()=>{
    getAxiosResponse(APIUrls.GET_ALL_COUNTRIES).then((res) => {
      var countryArray = [];
      res.data.data.map((country) => {
        countryArray.push({
          label: country.displayName,
          value: country,
        });
      });
      setAllCountries(countryArray);
      //focusRef.current.focus()
    });
  };

  useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])

  const getAllAvailableIndustries = ()=>{
    getAxiosResponse(APIUrls.GET_ALL_INDUSTRIES_AVAILABLE).then((res) => {
      var industryArray = [];
      res.data.data.map((industry) => {
        industryArray.push({
          label: industry.display,
          value: industry,
        });
      });
      setAllIndustries(industryArray);
      //focusRef.current.focus()
    });
  };

  useEffect(()=>{
    getCompanyInfo();
    getStripsInfo();
    getAllCountries();
    getAllAvailableIndustries();
    if(editMode){
      disableSave();
    }
  },[editMode]);
  

  $(document).on("click",".dashboard-btn",function() {
    $('.focusClick').trigger('focus');
  });

  const toggleCheckBox = (flag)=>{
    enableSave();
    let customerPerf = customerPreference;
    setStatus(flag);
    customerPerf.status = flag;
    setCustomerPreference(customerPerf);
  };

  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Company information', url:''},
  ];

  const enableSave = ()=>{
    const saveBtn = $("#save-btn");
    if(saveBtn.hasClass("disabled-btn")){
      saveBtn.removeClass("disabled-btn");
    }
  };

  const disableSave = ()=>{
    const saveBtn = $("#save-btn");
    if(!saveBtn.hasClass("disabled-btn")){
      saveBtn.addClass("disabled-btn");
    }
  };

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
           <Breadcrumb crumbs={ crumbs } />
            <div className="system-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center" onClick={() => {navigate("/settings");}}>
                  <button ref={backRef} aria-label="back" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none" >
                      <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8" />
                    </svg>
                  </button>
                  <span>Back to Settings</span>
                </div>
                <h3>Company Information</h3>
                <span>
                  Edit your organization's name, address, and financial contact
                  information.
                </span>
              </div>
              <div className="white-bg">
              {!editMode ? 
                (<>
                  <div className="setting-info-readonly" >
                    <div className="flex heading-with-rightbtn">
                      <h6>Contact Information, Financial Information</h6>
                      <div className="flex two-col flex-center">
                        <button className="dashboard-btn" onClick={companyInfoEdit} >
                          Edit
                        </button>
                      </div>
                    </div>
                    <div className="setting-info-data">
                      <h6>Contact Information</h6>
                      <address>
                        {companyInfo.name}
                        <br />
                        {(!companyInfo.address1 || !companyInfo.city || !companyInfo.zip || !companyInfo.country) ? 
                          (
                          <span className="error">Please complete your organization information by clicking Edit.</span>
                          ) : (
                          <>
                            {companyInfo.address1} ,{" "}
                            {companyInfo.address2 ? companyInfo.address2 : ""}{" "}
                            <br />
                            {companyInfo.city} ,{" "}
                            {companyInfo.state ? companyInfo.state : ""}{" "}
                            {companyInfo.zip}
                            <br />
                            {companyInfo.country.displayName} <br />
                          </>
                        )}
                        {companyInfo.phone}
                      </address>
                    </div>
                    <div className="setting-info-data">
                      <h6>Financial Information</h6>
                      <address>
                        {companyInfo.financialContactName}
                        <br />
                        {companyInfo.financialContactEmail}
                        <br />
                        {companyInfo.financialContactPhone}
                        <br />
                      </address>
                      {companyInfo.vatNumber ? (
                        <>
                          <h6>VAT No</h6>
                          <address>\${companyInfo.vatNumber} </address>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    {customerData?.features?.STRIPE?
                      (
                      <div className="setting-info-data">
                        <h6>Credit Card Payments:</h6>
                        <address>
                          {customerPreference?.status==="true" ? "Enabled":"Disabled"}
                        </address>
                      </div>
                    ):Constants.BLANK}
                  </div>
                </>):
                (<>
                  <div className="profile-editonly-block">
                    <div className="setting-info-list mar-bot20">
                      <h5 className="heading-width-border">Company Details</h5>
                      <div className="profile-edit-form">
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                            <label>Company Name</label>
                            <input type="text" className="form-control-sm focusClick" title="Company Name" 
                              value={companyName}
                              name="companyname"
                              onChange={(e) => {
                                enableSave();
                                setCompanyName(e.target.value);
                              }}
                              //ref={focusRef} 
                              />
                              {errors.companyname && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.companyname}
                                </div>
                              }
                          </div>
                          <div className="global-dropdown-block">
                            <label>Street</label>
                            <input type="text" className="form-control-sm" title="Street" value={address1}
                            name="address1"
                              onChange={(e) => {
                                enableSave();
                                setCompanyAddress1(e.target.value)
                              }} />
                              {errors.address1 && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.address1}
                                </div>
                              }
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                            <label>Floor/Suite <span>Optional</span></label>
                            <input type="text" className="form-control-sm" title="Floor/Suite" value={address2}
                            name="address2"
                              onChange={(e) => {
                                enableSave();
                                setCompanyAddress2(e.target.value)
                              }} />
                              {errors.address2 && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.address2}
                                </div>
                              }
                          </div>
                          <div className="global-dropdown-block">
                            <label>City</label>
                            <input type="text" className="form-control-sm" title="City" 
                            name="city"
                            value={city} onChange={(e) => {
                              enableSave();
                              setCompanyCity(e.target.value)
                            }}/>
                            {errors.city && 
                              <div className="error" aria-label="error alert" role="alert">
                                {errors.city}
                              </div>
                            }
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                            <label>State <span>Optional</span></label>
                            <input type="text" className="form-control-sm" title="State"
                            name="state"
                              value={state} onChange={(e) => {
                                enableSave();
                                setCompanyState(e.target.value)
                              }}/>
                              {errors.state && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.state}
                                </div>
                              }
                          </div>
                          <div className="global-dropdown-block">
                            <label>Zip Code</label>
                            <input type="text" className="form-control-sm" title="Zip Code"
                            name="zipcode"
                              value={zipcode} onChange={(e) => {
                                enableSave();
                                setCompanyZipcode(e.target.value)
                              }} />
                              {errors.zipcode && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.zipcode}
                                </div>
                              }
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                            <label>Country</label>
                            <Select classNamePrefix='cw' className="global-dropdown-select isselectRemove"
                            name="country"
                              value={countries.filter(function (option) {
                                  return option.value.country === selectedCountry.country;
                              })}
                              aria-label="Country"
                              options={countries}
                              onChange={(e) => handleCountrySelect(e)}
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true} 
                            />
                             {errors.country && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.country}
                                </div>
                              }
                          </div>
                          <div className="global-dropdown-block">
                            <label>Industry</label>
                            <Select classNamePrefix='cw'
                              className="global-dropdown-select isselectRemove"
                              name="industry"
                              value={industries.filter(function (option) {
                                  return option.value.value === selectedIndustry.value;
                              })}
                              aria-label="Industry"
                              options={industries}
                              onChange={(e) => handleIndustrySelect(e)}
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true} 
                            />
                             {errors.industry && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.industry}
                                </div>
                              }
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                            <label>Company Phone Number</label>
                            <input type="number" className="form-control-sm" title="Company Phone Number"
                            name="phonenumber"
                              value={phoneNumber}
                              onChange={(e) =>{
                                enableSave();
                                setCompanyPhoneNumber(e.target.value);
                              }
                              }
                            />
                            {errors.phonenumber && 
                              <div className="error" aria-label="error alert" role="alert">
                                {errors.phonenumber}
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="setting-info-list mar-bot20">
                      <h5 className="heading-width-border">
                        Financial Information
                      </h5>
                      <div className="profile-edit-form">
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                            <label>Accounts Payable Contact Name</label>
                            <input type="text" className="form-control-sm" title="Accounts Payable Contact Name"
                              value={accountPayableName}
                              name="accountpayablename"
                              onChange={(e) => {
                                enableSave();
                                setCompanyAccountPayableContactName(e.target.value)
                              }}/>
                              {errors.accountpayablename && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.accountpayablename}
                                </div>
                              }
                          </div>
                          <div className="global-dropdown-block">
                            <label>Accounts Payable Email</label>
                            <input type="email" className="form-control-sm" title="Accounts Payable Email"
                              value={accountPayableEmail}
                              name="accountpayableemail"
                              onChange={(e) => {
                                enableSave();
                                setCompanyAccountPayableEmail(e.target.value)
                              }} />
                              {errors.accountpayableemail && 
                              <div className="error" aria-label="error alert" role="alert">
                                {errors.accountpayableemail}
                              </div>
                              }
                          </div>
                        </div>

                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                            <label>Accounts Payable Phone</label>
                            <input type="number" className="form-control-sm" title="Accounts Payable Phone"
                              value={accountPayablePhone}
                              name="accountpayablephone"
                              onChange={(e) => {
                                enableSave();
                                setCompanyAccountPayablePhone(e.target.value) 
                              }} />
                              {errors.accountpayablephone && 
                                <div className="error" aria-label="error alert" role="alert">
                                  {errors.accountpayablephone}
                                </div>
                                }
                          </div>
                          {customerData?.features?.STRIPE?
                          (<div className="purchase-yesno-list mar-bot40">
                            <h5 className="heading-width-border">Can users pay for projects with a credit card?</h5>
                            <div className="radio-form-check">
                              <input type="radio" className="form-check-input" name="radio" id="no" 
                              checked={(status === "false")} 
                              onChange={()=>toggleCheckBox("false")} />
                              <label className="form-check-label" htmlFor="no">
                                No
                              </label>
                            </div>
                            <div className="radio-form-check">
                              <input type="radio" className="form-check-input" title="Yes" 
                                checked={status === "true"} 
                                onChange={()=>toggleCheckBox("true")}
                                name="radio" id="yes" />
                              <label className="form-check-label" htmlFor="yes">
                                Yes
                              </label>
                            </div>
                          </div>):Constants.BLANK}
                        </div>
                      </div>
                    </div>
                  </div>
                </>)
              }
              </div>
            </div>
          </div>
        </section>
      </div>
      {editMode ?
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button className="btn-default" onClick={() => setToggleEditMode(!editMode)}>
              Cancel
            </button>
          </div>
          <div>
            <button id="save-btn" className="btn-default disabled-btn" onClick={updateCompanySetting}>
              Save
            </button>
          </div>
        </div>
      </div>
      :Constants.BLANK}
    </div>
  );
}
